'use client'

import { ChevronRight } from 'lucide-react'

import { Tooltip } from '~/components/component-library'
import { cn } from '~/utils/tailwind-utils'

export const AccountBanner = ({
  icon,
  title,
  description,
  onClick,
  isDisabled = false,
  disabledReason,
}: {
  icon: React.ReactNode
  title: React.ReactNode
  description: React.ReactNode
  onClick: () => void
  isDisabled?: boolean
  disabledReason?: string
}) => (
  <Tooltip
    triggerClassName="relative flex w-full"
    content={disabledReason}
    isDisabled={!isDisabled}
  >
    <button
      type="button"
      className={cn(
        'flex w-full items-center justify-between rounded-md border border-default bg-transparent p-2 text-left focus:ring-0 dark:bg-transparent',
        {
          'hover:bg-surface-muted': !isDisabled,
          'cursor-not-allowed': isDisabled,
        },
      )}
      onClick={() => {
        if (!isDisabled) onClick()
      }}
    >
      <div className="flex w-full items-center space-x-2">
        <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-blue-500">
          {icon}
        </div>
        <div className="flex flex-col items-start">
          <div className="text-sm font-medium text-primary">{title}</div>
          <div className="text-xs text-secondary">{description}</div>
        </div>
      </div>
      <ChevronRight className="h-10 w-5 flex-shrink-0 text-primary" />
    </button>
  </Tooltip>
)
